import React, { PropTypes } from 'react';
import Loader from 'halogen/RotateLoader';
import { blueGrey800 } from 'material-ui/styles/colors';

const MyLoader = () => {
  return (
      <div style={{width:'80%', position:'absolute', height:'50%'}}>
          <div style={{textAlign:'center', position:'absolute', top: '50%', left:'50%'}}>
              <Loader color={blueGrey800} size="15px" margin="2px"/>
          </div>
      </div>
  );
};

MyLoader.propTypes = {
};

export default MyLoader;


/** WEBPACK FOOTER **
 ** ./src/components/MyLoader/index.js
 **/